const ITEMS = [
  "Transparent Communication",
  "Responsible Guidance",
  "Bank & NBFC Coordination",
  "Simple Documentation",
  "Customer-First Assistance",
  "Pan-India Reach",
  "No Hidden Charges",
  "Professional Support",
];

const Diamond = () => (
  <span className="inline-block w-1.5 h-1.5 rotate-45 bg-[#D4AF37] mx-8 shrink-0" aria-hidden="true" />
);

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display text-sm sm:text-base tracking-[0.18em] uppercase text-[#A1A1AA]">{item}</span>
          <Diamond />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee-ticker"
      className="marquee-mask overflow-hidden border-y border-[rgba(212,175,55,0.15)] bg-[#0C0C10] py-5"
    >
      <div className="animate-marquee flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
